import styled from 'styled-components'
import Flex from 'components/Flex'
import { COLORS } from 'theme'
import Button from 'components/Button/index'
import { Collapse,Divider, Menu, Row, Col  } from 'antd'

export const SectionWrapper = styled(Flex)`
  width: 100%;

  overflow-y: scroll;
`
export const OuterDiv = styled.div`
  border: 1px solid ${COLORS.PAGE_BORDER};
  background: ${COLORS.WHITE};
  box-shadow: 0px 2px 6px rgba(123, 97, 255, 0.15);
  margin: 30px 100px 20px 100px;
  border-radius: 10px;

  @media only screen and (max-device-width: 767px) {
    margin: 10px;
  }
  @media only screen and (min-width: 1200px) and (max-width: 1300px) {
    margin: 30px 20px 20px 20px;
  }
  @media only screen and (min-width: 768px )  and  (max-width : 1200px){
    margin: 10px;
  }
`

export const TopHeader = styled(Flex)`
  padding: 20px 25px;
  position: relative;
  width: 100%;
  font-size: 2em;
`
export const TopHeading = styled(Flex)`
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  color: ${COLORS.GREY_P_100};
`
export const ShowNum = styled(Flex)`
  font-style: normal;
  font-weight: 700;
  padding-top: 10px;
  padding-right: 15px;
  font-size: 13px;
  line-height: 18px;
  color: ${COLORS.GREY_T_30};
`
export const AnchorText = styled.a`
  font-style: normal;
  font-weight: 500;
  padding-top: 10px;
  padding-right: 25px;
  font-size: 13px;
  line-height: 18px;
  color: ${COLORS.PRIMARY};
`

export const TopRightFlex = styled(Flex)`
  gap: 15px;
`
export const SmallButtons = styled(Button.Default)`
  background: ${COLORS.WHITE};
  padding: 9px;
  > div {
    margin-left: 0;
  }
`
export const CardRow = styled(Flex)`
  padding: 0 25px 25px 25px;
  gap: 20px;
`

export const FilterCollapse = styled(Collapse)`
  background-color: #fafafb !important;

  .ant-collapse-header {
    position: relative;
    display: flex;
    flex-wrap: nowrap;
    align-items: flex-start;
    padding: 10px !important;
    font-weight: 600;
    border-radius: 10px !important;
    border-radius: 5px;
    color: ${COLORS.GREY_T_60} !important;
    line-height: 1.5715;
    cursor: pointer;
    transition: all 0.3s, visibility 0s;
  }
`

export const Main = styled.div`
  margin: 15px 0;
`
export const MainHeading = styled.h1`
  margin-bottom: ${props => (props.marginBottom ? props.marginBottom : '30px')};
  padding-top: ${props => (props.paddingTop ? props.paddingTop : '5px')};
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  margin-right: 30px;
  color: ${COLORS.GREY_T_10};
`
export const SecondaryHeading = styled.h2`
  margin-bottom: ${props => (props.marginBottom ? props.marginBottom : '10px')};
  font-style: normal;
  padding: 0px;
  font-weight: ${props => (props.fontWeight ? props.fontWeight : '700')};
  font-size: 16px;
  line-height: 21px;
  text-transform: capitalize;
  color: ${COLORS.GREY_T_10};
`
export const SecondaryHeadingNew = styled.h2`
  margin-bottom: ${props => (props.marginBottom ? props.marginBottom : '10px')};
  font-style: normal;
  padding: 0px;
  font-weight: ${props => (props.fontWeight ? props.fontWeight : '700')};
  font-size: 18px;
  line-height: 21px;
  text-transform: capitalize;
  color: ${COLORS.GREY_T_10};
`



export const FullTimeBox = styled.div`
  background-color: #F2F3F5;
  color: #808697;
  display: inline-block;
  font-size: 13px;
  font-weight: 600;
  padding: 0px 15px 0px 15px;
  border-radius: 10px;  // Add the desired border radius
  border: 1.2px solid #CCCFD6;  // Add the desired border color
  `;


export const StyledP = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: ${COLORS.GREY_T_50};
  ${props => props.webkitBox && `display: -webkit-box`};
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  // overflow: hidden;
  text-overflow: ellipsis;
  overflow-wrap: break-word;
`
export const StyledDivider = styled(Divider)`
  margin: ${props => (props.margin ? props.margin : '15px 0')};
`
export const SubFLex = styled(Flex)`
  ${props => props.gap && `gap: ${props.gap};`}
  ${props => props.marginBottom && ` margin-bottom: ${props.marginBottom};`};
`
export const GreyText = styled.p`
text-transform: capitalize;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  color: ${props => (props.color ? props.color : COLORS.GREY_T_40)};
  span {
    margin-right: 10px;
  }
`
export const GreyText1 = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${props => (props.color ? props.color : COLORS.GREY_T_40)};
  span {
    margin-right: 10px;
  }
`
export const Marks = styled.p`
width:inherit;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
  text-align: right;
  color: ${COLORS.GREY_T_10};
  span {
    color: ${COLORS.GREY_T_60};
  }
`
export const SecondGreyText = styled.p`
  margin-bottom: ${props => (props.marginBottom ? props.marginBottom : '8px')};
  font-style: normal;
  font-weight: 600;
  font-size: 0.875em;
  line-height: 1.4em;
  color: ${props => (props.color ? props.color : COLORS.GREY_T_40)};
  overflow-wrap: break-word;
  overflow: hidden;
`
export const OtherFlex = styled(Flex)`
  width: 40%;
  margin-right: 30px;
`
export const DrawerHeader = styled(Flex)`
  gap: 20px;
  width: 98%;
`
export const HeaderFlexOne = styled(Flex)`
  gap: 10px;
  width: 75%;
`
export const InfoSection = styled(Flex)`
  gap: 5px;
  margin-left: 10px;
`
export const StudentName = styled.h2`
  margin-bottom: 0;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: ${COLORS.GREY_T_100};
`
export const CollegeName = styled.p`
  margin-bottom: 0;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.1em;
  color: ${COLORS.GREY_T_50};
  display: flex;
  gap: 10px;
  align-items: center;
`
export const NavHeading = styled.h2`
  margin-bottom: 18px;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  color: inherit;
  margin-bottom: 0;
`
export const StudentInfoFlex = styled(Flex)``

export const SectionNavMenu = styled(Menu)`
  font-weight: 600;
  padding-top: 10px;
  .ant-menu-item{
    padding: 0 15px !important;
  }
`
export const MenuItem = styled(Menu.Item)`
padding: 0 10px;
`
export const GeneralEditIcon = styled.div`
  float: right;
  padding-right: 5px;
  padding-top: 8px;
`

export const RowwithPadding = styled(Row)`
  padding: 20px;
`

export const PersonalEditIcon = styled.div`
  position: relative;
  right: -34%;
  padding-top: 20px;
`

export const LeftCol = styled(Col)`
  padding-right: 20px;
`
export const RightDiv = styled.div`
  border-left: 1px solid #e6e7ea;
  padding: 20px;
`

export const Name = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;

  color: #1a2645;
  text-align: center;
`

export const Address = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;

  color: #1a2645;
  text-align: center;
`
export const NameAdd1 = styled(Flex)`
  gap: 3px;

`
export const NameAdd = styled(Flex)`
  gap: 3px;
  padding-left: 15px;
`
export const ViewIcon = styled.div`
  position: absolute;
  right: 10%;
`
export const EditorContent = styled.span`
  padding: 20px 0;
  * {
    line-height: 188%;
    color: #808697 !important;
  }
  p,
  ul,
  ol {
    margin-bottom: 10px;
  }

  li {
    line-height: 25px;
  }

`
export const ModalImg = styled.img`
height: 250px;
width: 100%;
`
export const RewardTite = styled.div`
font-style: normal;
font-weight: 700;
font-size: 13px;
line-height: 18px;
color: #1B1F22;
padding-bottom:10px;
`
export const RewardTiteNew = styled.div`
font-style: normal;
font-weight: 700;
font-size: 16px;
line-height: 18px;
color: #1B1F22;
padding-bottom:10px;
`
export const VerticalDivider = styled(Divider)`
  height: 50px;
`
export const TextLight1 = styled.div`
font-style: normal;
font-weight: 500;
font-size: 12px;
line-height: 15px;
display: flex;
align-items: center;
color: #676E83;
`

export const BoldTextDate = styled.div`
font-style: normal;
font-weight: 600;
font-size: 16px;
line-height: 21px;
align-items: center;
color: #343E59;

`
